// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "PageDescription-module--bx--text-truncate--end--ylpqK";
export var bxTextTruncateFront = "PageDescription-module--bx--text-truncate--front--2FwZx";
export var pageDescription = "PageDescription-module--page-description--KlfP-";